module.exports = __webpack_public_path__ + "static/media/29ADMSPC15.6a0dc220.jpg";